import React from 'react';
import useIsMobile from '../../utils/useIsMobile';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import Button from '../elements/Button';
import { useLanguage } from '../../contexts/LanguageContext';

const propTypes = {
  ...SectionProps.types,
};

const defaultProps = {
  ...SectionProps.defaults,
};

const Hero = ({ className, topOuterDivider, bottomOuterDivider, topDivider, bottomDivider, hasBgColor, invertColor, ...props }) => {
  const { lang } = useLanguage();
  const isMobile = useIsMobile();

  const webWaUrl =
    'https://web.whatsapp.com/send?phone=19544708414&text=Hello,%20I%20want%20an%20AI%20agent%20inside%20my%20Moodle%20course.';
  const mobileWaUrl =
    'whatsapp://send?phone=19544708414&text=Hello,%20I%20want%20an%20AI%20agent%20inside%20my%20Moodle%20course.';

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className,
  );

  const innerClasses = classNames('hero-inner section-inner', topDivider && 'has-top-divider', bottomDivider && 'has-bottom-divider');

  const content = {
    en: {
      eyebrow: 'AI for Education, Moodle First',
      title: (
        <>
          AI Tutors That Live
          <br />
          Inside <span className="word-accent">Moodle.</span>
        </>
      ),
      desc: 'We build chatbots that answer student questions inside your Moodle course, using only the course material. Every answer cites the unit and page, 24 hours a day.',
      cta: 'Start on WhatsApp',
      ctaEmail: 'Send an Email',
      ctaSecondary: 'See It Running',
      stats: [
        { number: '24/7', label: 'Inside the course' },
        { number: 'Moodle', label: 'Native, no new login' },
        { number: '3', label: 'Steps to go live' },
      ],
    },
    es: {
      eyebrow: 'IA para Educación, Moodle Primero',
      title: (
        <>
          Tutores de IA Que
          <br />
          Viven en <span className="word-accent">Moodle.</span>
        </>
      ),
      desc: 'Construimos chatbots que responden las dudas de tus alumnos dentro de tu curso en Moodle, solo con el material del curso. Cada respuesta cita la unidad y la página, las 24 horas.',
      cta: 'Empezar por WhatsApp',
      ctaEmail: 'Enviar Email',
      ctaSecondary: 'Verlo Funcionando',
      stats: [
        { number: '24/7', label: 'Dentro del curso' },
        { number: 'Moodle', label: 'Nativo, sin login nuevo' },
        { number: '3', label: 'Pasos para activarlo' },
      ],
    },
  };

  const c = content[lang];

  return (
    <section {...props} className={outerClasses}>
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <div className="reveal-from-bottom" data-reveal-delay="100">
              <span className="hero-eyebrow">{c.eyebrow}</span>
            </div>
            <h1 className="mt-0 mb-16 reveal-from-bottom" data-reveal-delay="200">
              {c.title}
            </h1>
            <div className="container-xs">
              <p className="hero-desc reveal-from-bottom" data-reveal-delay="350">
                {c.desc}
              </p>
              <div
                className="reveal-from-bottom"
                data-reveal-delay="500"
                style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}
              >
                <Button tag="a" target="_blank" color="primary" href={isMobile ? mobileWaUrl : webWaUrl}>
                  {c.cta}
                </Button>
                <Button
                  tag="a"
                  href="mailto:info@e-comienza.com"
                  style={{
                    background: 'rgba(255,255,255,0.06)',
                    border: '1px solid rgba(255,255,255,0.12)',
                    color: '#ECEDED',
                    borderRadius: '100px',
                    padding: '14px 32px',
                    fontWeight: 700,
                    textDecoration: 'none',
                  }}
                >
                  {c.ctaEmail}
                </Button>
                <Button
                  tag="a"
                  color="dark"
                  href="#work"
                  style={{
                    background: 'transparent',
                    border: 'none',
                    color: 'var(--ec-muted)',
                    padding: '14px 16px',
                    fontWeight: 600,
                    textDecoration: 'none',
                    fontSize: '0.9rem',
                  }}
                >
                  {c.ctaSecondary} ↓
                </Button>
              </div>
            </div>
            <div className="hero-stats reveal-from-bottom" data-reveal-delay="700">
              {c.stats.map((stat, i) => (
                <div className="hero-stat" key={i}>
                  <span className="hero-stat-number">{stat.number}</span>
                  <span className="hero-stat-label">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;
